export default [
  { name: 'paymentsmb-milkbox-brands', path: 'milkbox/brands/:id?/:section?', component: () => import('../milkbox/pages/Brands.vue') }
]
